// extracted by mini-css-extract-plugin
export var label = "RefinementListWrapper-module--label--9431d";